import React, { useEffect, useRef, useState } from "react";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Home from "./components/Home";
import CssOnly from "./components/scrolls/parallax/cssonly";
import ScrollTriggers from "./components/scrolls/scrolltriggers";
import ScrollSection from "./components/scrolls/ScrollHoz";

import Logo from "./images/logo.svg";

import "./components/app.scss";
import "./app.css";

function App() {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPoint, setSelectedPoint] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  });

  const sectionRef = useRef(null);

  const ScrollHowToUse = () => {
    if (sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };


  

  return (
    <div className="main-container">
      {isLoading ? (
        <div className="splash-screen">
          <img src={Logo} class="img-fluid" alt="logo" />
          <h2 className="zoom-text">Decentralized Team Awareness Kit</h2>
        </div>
      ) : (
        <>
          <Header scrollToSection={ScrollHowToUse} />
          <Home sectionRef={sectionRef} />
          <CssOnly />
          <ScrollTriggers />
          <ScrollSection />
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
